import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=6c3e1f12&lang=pug&"
import script from "./Preferences.vue?vue&type=script&lang=ts&"
export * from "./Preferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports